module.exports = __webpack_public_path__ + "static/media/SUNDARBAN.978671e9.png";